import * as React from 'react';

import { Grid,  Button } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import Tabela from './Tabela';
import { NoResult } from 'components/NoResult';
import Pagination, { calculateRange } from 'components/Pagination';
import { sendErrorLog } from 'common/helpers';

export type DoladowaniaType = {
    data: string;
    opis: string;
} 


interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  paginacja: number[],
  tabela: DoladowaniaType[],
}

class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      paginacja: [0, 1, 10],
      tabela: [],
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'twoje wypozyczenia')
    this.getTabela()
  }

  getTabela = () => {
    let tabela = [
      // {
      //   data: "2024-11-25 08:45",
      //   opis: "72.80",
      // },
      // {
      //   data: "2024-11-21 09:23",
      //   opis: "135.00",
      // },
      // {
      //   data: "2024-11-21 09:07",
      //   opis: "56.70",
      // },
      // {
      //   data: "2024-11-19 08:50",
      //   opis: "78.50",
      // },
  ]

  this.setState({tabela: tabela})
  }

  updateSkip = async (aPage: number) => {
    const newSkip = (aPage - 1) * this.state.paginacja[2]
    this.setState({ paginacja: [newSkip, aPage, this.state.paginacja[2]] })
  }
  changeRowsPerPage = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    this.setState({ paginacja: [0, 1, Number(event.target.value)] })
  }

  
  render() {
    const { classes, t } = this.props;
    
    let ilosc = this.state.tabela.length
    const range = calculateRange(ilosc, this.state.paginacja[2])
    
    let tabela: DoladowaniaType[] = this.state.tabela;
    tabela = tabela.slice(this.state.paginacja[0], this.state.paginacja[0] + this.state.paginacja[2]) 
   

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} style={{maxWidth: "370px", margin: "auto", paddingLeft: 0, paddingRight: 0}}>
                 
              {
                tabela.length === 0 ?
                  <NoResult text={'Czekamy na Twoje wypożyczenia'}/> :
                  <>
                    <Tabela
                      tableBody={tabela}
                      icon
                      />

                  <Pagination
                    page={this.state.paginacja[1]}
                    range={range}
                    updateSkip={this.updateSkip}
                    changeResultsPerPage={this.changeRowsPerPage}
                    resultsPerPage={this.state.paginacja[2]}
                    tableLength={ilosc}
                  />


                  </>}


              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
    container1: {
        //margin: "0em",
        //paddingTop: "0.4em",
        margin: "12px auto 0px",
        padding: '0em 0em',
        minHeight: "100%",
        maxWidth: "1340px",
        //border: "2px solid lavender"
      },
      gridItem: {
        minHeight: "150px",
      },
      
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

